var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507 189.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "STZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,188.89l34-40.6c2.62,1.94,5,3.71,7.42,5.51,14.72,11,31.14,17.59,49.67,17.14,4.31-.1,8.55-3.25,12.82-5-3.51-2.55-6.67-6.17-10.59-7.44-10.31-3.36-21-5.5-31.45-8.51a141.19,141.19,0,0,1-18.23-6.58c-19.74-8.79-32.24-23-33.08-45.59-.86-23.17,8-41.37,28-53.54C57.86,34,76.56,32.18,95.74,33.41c25.54,1.63,48.53,9.77,68.78,27.69l-30.17,42.66c-7.64-4.29-14.2-9.38-21.64-11.81-10.16-3.32-20.93-4.93-31.56-6.5-2.24-.33-5,2.72-7.47,4.21,2,2,3.66,5.1,6.06,5.87,9.09,2.92,18.51,4.84,27.65,7.63,9.38,2.86,18.87,5.66,27.83,9.57,45.71,19.93,37.84,77.88,7,96.15-10.62,6.29-23.13,11.1-35.3,12.73-36.14,4.84-69.41-3.47-98.13-27C6.81,193,5,191.18,2.5,188.89Z",
    transform: "translate(-2.5 -33.08)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M495.68,165.56v53.67H333.91L411.24,91.39H352V38.14H509.5L432.41,165.56Z",
    transform: "translate(-2.5 -33.08)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.05,219V91.46H172.31V38.13H334v52.8H283.29V219Z",
    transform: "translate(-2.5 -33.08)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9be5504add9d30e59097ef856264b1f5.svg";
export { ForwardRef as ReactComponent };